module.exports = __webpack_public_path__ + "images/powerups/calendar-icon.ff818ba7df38d8af7f68.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/calendar-icon.svg
// module id = vlw4
// module chunks = 0